import { render, staticRenderFns } from "./serviceGoodsAdd.vue?vue&type=template&id=08bc9444&scoped=true"
import script from "./serviceGoodsAdd.vue?vue&type=script&lang=js"
export * from "./serviceGoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./serviceGoodsAdd.vue?vue&type=style&index=0&id=08bc9444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc9444",
  null
  
)

export default component.exports